export interface StatsUrgencyApi
{
    urgencyId: number;
    count: number;
    percent: number;
}

export class StatsTicketingApi
{
    incidents: StatsUrgencyApi[];
    requests: StatsUrgencyApi[];
}
